import Marquee from "react-fast-marquee";

const LOGOS = [
    { name: "Client 1", src: "/logos/1.png" },
    { name: "Client 2", src: "/logos/2.png" },
    { name: "Client 3", src: "/logos/3.png" },
    { name: "Client 4", src: "/logos/4.png" },
    { name: "Client 5", src: "/logos/5.png" },
    { name: "Client 6", src: "/logos/6.png" },
    { name: "Client 7", src: "/logos/7.png" },
    { name: "Client 8", src: "/logos/8.png" },
    { name: "Client 9", src: "/logos/9.png" },
    { name: "Client 10", src: "/logos/10.png" },
    { name: "Client 11", src: "/logos/11.png" },
    { name: "Client 12", src: "/logos/12.png" },
    { name: "Client 13", src: "/logos/13.png" },
    { name: "Client 14", src: "/logos/14.png" },
    { name: "Client 15", src: "/logos/15.png" },
    { name: "Client 16", src: "/logos/16.png" },
    { name: "Client 17", src: "/logos/17.png" },
    { name: "Client 18", src: "/logos/18.png" },
    { name: "Client 19", src: "/logos/19.png" },
    { name: "Client 20", src: "/logos/20.png" },
    { name: "Client 21", src: "/logos/21.png" },
    { name: "Client 22", src: "/logos/22.png" },
];

export default function Clients() {
    return (
        <section
            id="clients"
            data-testid="clients-section"
            className="relative bg-white py-20 border-y border-communiti-line"
        >
            <div className="mx-auto max-w-[1440px] px-6 lg:px-10 mb-10 flex items-end justify-between">
                <p className="label-eyebrow">Trusted by growing brands</p>
                <p className="hidden sm:block text-xs text-communiti-muted">
                    120+ partnerships worldwide
                </p>
            </div>

            <div className="marquee">
                <Marquee gradient gradientColor={"rgb(255,255,255)"} speed={45} pauseOnHover>
                    {LOGOS.map((l, i) => (
                        <div
                            key={i}
                            data-testid={`client-logo-${l.name.toLowerCase()}`}
                            className="mx-4 md:mx-6 lg:mx-8"
                        >
                            <div className="relative h-12 w-12 md:h-16 md:w-16 lg:h-20 lg:w-20 xl:h-24 xl:w-24 flex items-center justify-center text-communiti-text/70 hover:text-communiti transition-colors duration-300">
                                <img
                                    src={l.src}
                                    alt={l.name}
                                    loading="lazy"
                                    className="max-h-full max-w-full object-contain"
                                />
                            </div>
                        </div>
                    ))}
                </Marquee>
            </div>
        </section>
    );
}
